export const mapSelectOptions = (array: any, val: string, label: string) => {
  let arr: any[] = []
  let obj: any = {}
  array.map((x: any) => {
    obj = {value: '', label: ''}
    obj.value = x[val]
    obj.label = x[label]
    arr.push(obj)
  })
  return arr
}
